import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  LicensePermission,
  UsersLicensPermissions,
} from '@account-users/account/models/LicensePermissionList';
import { License } from '@account-users/account/models/License';
import { removeItemFromArray } from '@shared';
import { AccountCategory } from '@account-users/account/models/AccountCategory';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-account-user-advanced-filter',
  templateUrl: './account-user-advanced-filter.component.html',
  styleUrls: ['./account-user-advanced-filter.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
})
export class AccountUserAdvancedFilterComponent {
  @Input() permissions: LicensePermission[] = [];
  @Input() licenses: License[] = [];
  @Input() accountCategories: AccountCategory[] = [];
  @Input() selectedAccountCategories: string[] = [];
  @Input() loadingFilter = false;
  @Input() showLicenseFilter = false;
  @Input() selectedLicenses: UsersLicensPermissions[] = [];
  @Input() selectedPermissions: UsersLicensPermissions[];

  @Output() categoriesChange: EventEmitter<any> = new EventEmitter();
  @Output() showHideLicensesFilter: EventEmitter<boolean> = new EventEmitter();
  @Output() selectLicense = new EventEmitter<UsersLicensPermissions>();
  @Output() selectPermission = new EventEmitter<object>();

  onShowHideLicensesFilter() {
    this.showHideLicensesFilter.emit(!this.showLicenseFilter);
  }

  changeAccountCategory(categoryCode: string) {
    this.selectedAccountCategories = this.selectedAccountCategories.includes(
      categoryCode,
    )
      ? removeItemFromArray(this.selectedAccountCategories, categoryCode)
      : [...this.selectedAccountCategories, categoryCode];

    this.categoriesChange.emit(this.selectedAccountCategories);
  }
}
